import styled from "styled-components";

import testimonialImgBorder from "../../../../image/home/testimonial-image-bg.svg";
import bulletsRectangle from "../../../../image/assets/bullet-rectangle.svg";
import zigzagShapeImgSrc from "../../../../image/assets/zigzag-shape.svg";

import { SectionTitleH3 } from "../companions/styledCompanions";
import { StyledSwiper } from "../simsCarousel/styledSimsCarousel";

export const StyledSection = styled.section`
  padding: 9rem 0;
  color: var(--text-color-dark);
  position: relative;
  overflow: hidden;
  @media screen and (min-width: 768px) {
    background: url(${zigzagShapeImgSrc}) no-repeat 99% 30%;
  }
  &::before,
  &::after {
    content: "";
    position: absolute;
  }
  &::before {
    background: url(${bulletsRectangle}) no-repeat;
    width: 210px;
    height: 202px;
    top: 100px;
    left: 5px;
    @media screen and (max-width: 576px) {
      transform: scale(0.6);
      top: 0;
      left: -75px;
    }
  }
  &::after {
    background: url(${zigzagShapeImgSrc}) no-repeat;
    bottom: 5%;
    right: 42px;
    width: 100px;
    height: 80px;
    @media screen and (max-width: 576px) {
      transform: scale(0.8);
      right: 25px;
    }
  }
`;

export const StyledTitleH3 = styled(SectionTitleH3)`
  width: fit-content;
  transform: none;
  @media screen and (max-width:768px) {
    font-size: var(--font-size-base);
  }
`;

export const TestimonialWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 450px 1fr;
  @media screen and (max-width: 576px) {
    grid-template-columns: 1fr 240px 1fr;
  }
  grid-column-gap: 6rem;
  @media screen and (max-width: 992px) {
    grid-column-gap: 2rem;
  }
  @media screen and (max-width: 576px) {
    grid-column-gap: 0.5rem;
  }
  @media screen and (max-width: 375px) {
    grid-column-gap: 0;
  }
`;

export const SideImgWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  img {
    border-radius: 20px;
    @media screen and (max-width: 768px) {
      width: 40px;
      height: 40px;
    }
  }
`;

export const MainImgWrapper = styled.div`
  width: 100%;
  background: url(${testimonialImgBorder}) center 14px/ 43% no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    border-radius: 20px;
  }
  @media screen and (max-width: 576px) {
    background-size: 55%;
    background-position: center;
    img {
      width: 48px;
      height: 48px;
    }
  }
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-rows: 200px;
  p {
    font-size: var(--font-size-sm);
  }
  small {
    font-size: var(--font-size-xs);
    font-weight: 700;
  }
`;

export const TestimonialSwiper = styled(StyledSwiper)`
  padding-bottom: 6rem;
  div.swiper-wrapper {
    padding: 0;
  }
`;
